export default __webpack_public_path__ + "static/media/logo.0fdb1be2.png";